import { useEffect } from "react";

export function JobsRedirectPage() {
  useEffect(() => {
    window.location.assign("/admin/jobs");
  }, []);
  return (
    <div className="p-6">
      <p>Redirecting to Hangfire dashboard…</p>
      <p className="text-sm text-muted-foreground">If you are not redirected automatically, <a className="underline" href="/admin/jobs">click here</a>.</p>
    </div>
  );
}
